<!-- Primary -->
<ng-container *ngIf="color === 'primary'">
  <button mat-flat-button color="primary" [disabled]="disabled"  >
    <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
  </button>
</ng-container>

<ng-container *ngIf="color === 'primary-stroked'">
  <button mat-stroked-button color="primary" [disabled]="disabled" >
    <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
  </button>
</ng-container> 

<ng-container *ngIf="color === 'primary-text'">
  <button mat-button color="primary" [disabled]="disabled"  >
    <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
  </button>
</ng-container>
<ng-container *ngIf="color === 'primary-opacity'">
  <button mat-stroked-button color="primary-opacity" [disabled]="disabled"  >
    <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
  </button>
</ng-container>
<!-- Secondary -->
<ng-container  *ngIf="color === 'accent'">
  <button [type]="type" mat-flat-button color="accent" [disabled]="disabled"  >
    <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
  </button>
</ng-container>

<ng-container *ngIf="color === 'accent-stroked'">
  <button mat-stroked-button color="accent" [disabled]="disabled"  >
    <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
  </button>
</ng-container>

<ng-container *ngIf="color === 'accent-text'">
  <button mat-button color="accent" [disabled]="disabled"  >
    <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
  </button>
</ng-container>
<ng-container *ngIf="color === 'accent-opacity'">
  <button mat-stroked-button color="accent-opacity" [disabled]="disabled">
    <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
  </button>
</ng-container>
<!-- Warn -->
<ng-container *ngIf="color === 'warn'">
  <button mat-flat-button color="warn"  >
    <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
  </button>
</ng-container>

<ng-container *ngIf="color === 'warn-stroked'">
  <button mat-stroked-button color="warn" [disabled]="disabled"  >
    <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
  </button>
</ng-container>

<ng-container *ngIf="color === 'warn-text'">
  <button mat-button color="warn" [disabled]="disabled"  >
    <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
  </button>
</ng-container>
<ng-container *ngIf="color === 'warn-opacity'">
  <button mat-stroked-button color="warn-opacity" [disabled]="disabled"  >
    <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
  </button>
</ng-container>
<ng-template #buttonContent>
  <ng-content></ng-content>
</ng-template>